<template>
  <nuxt-child />
</template>

<script>
export default {
  name: 'TermLetter',
  validate({ params: { letter } }) {
    return !!letter
  }
}
</script>
